import React, { Component } from 'react';
import RoundIcon from './../RoundIcon/RoundIcon';
import SectionBlock from './../SectionBlock/SectionBlock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import ReportSectionHeading from './../ReportSectionHeading/ReportSectionHeading';
import style from './style/multiplerankingsection.scss'; // eslint-disable-line

export default class MultipleRankingSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openToolTip: false,
            classTooltip: 'display_none'
        };

        this.showTooltipModalHandler = this.showTooltipModalHandler.bind(this);
    }

    showTooltipModalHandler() {
        if (this.state.openToolTip === false) {
            this.setState({
                ...this.state,
                openToolTip: true,
                classTooltip: 'displayBlock'
            });
        } else if (this.state.openToolTip === true) {
            this.setState({
                ...this.state,
                openToolTip: false,
                classTooltip: 'display_none'
            });
        }
    }

    render() {
        const { classes, title, iconText, children, faIconString, profileIntroHeader } = this.props;

        return (
            <SectionBlock
                classes={{
                    root: `${style.sectionBlock} ${classes.root ? classes.root : ''}`,
                    contentWrapper: classes.contentWrapper,
                    badge: classes.badge
                }}
            >
                <ReportSectionHeading
                    title={ title }
                    iconType={ faIconString }
                    iconText={ iconText }
                    introHeading={ !!profileIntroHeader }
                    introHeadingIcon={ 'info-circle' }
                    introHeadingAction={ this.showTooltipModalHandler }
                    classes={{
                        reportSectionHeading: classes.reportSectionHeading,
                        roundIcon: {
                            root: classes.roundIcon.root,
                            roundIconFigureWrapper: classes.roundIcon.roundIconFigureWrapper
                        }
                    }}
                />

                { profileIntroHeader ? <div className={ `${style.intro_tooltip_container} ${this.state.classTooltip}` }>
                    <div className={ style.heading_intro_text }>{ profileIntroHeader }</div>
                </div> : null }

                <section className={ `${style.output} ${classes.output ? classes.output : ''}` }>
                    { children }
                </section>
            </SectionBlock>
        );
    }
}

MultipleRankingSection.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    iconText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.array,
    faIconString: PropTypes.string,
    profileIntroHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

MultipleRankingSection.defaultProps = {
    classes: {
        root: '',
        output: '',
        contentWrapper: '',
        roundIcon: {
            root: '',
            roundIconFigureWrapper: ''
        }
    },
    title: '',
    iconText: '',
    children: [],
    faIconString: '',
    profileIntroHeader: ''
};
